import * as yup from 'yup';
import { EMAIL_ERROR_FORMAT, REQUIRED_FIELD } from '../../constants';

export const validationSchema = yup.object({
  email: yup.string().email(EMAIL_ERROR_FORMAT).required(REQUIRED_FIELD),
  password: yup.string().min(6).required(REQUIRED_FIELD),
});
